<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/BeerClaimReport/AmountBeerClaim'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่เริ่มต้น:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reStartDate"
                      name="reStartDate"
                      ref="reStartDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่สิ้นสุด:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reEndDate"
                      name="reEndDate"
                      ref="reEndDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เขตการขาย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reSalesArea'"
                    :name="'reSalesArea'"
                    :select2-options="reSalesAreaOptions"
                    multiple
                    v-model="reDepartments"
                  ></select2> -->
                  <treeselect
                    v-model="reSalesArea"
                    :multiple="true"
                    :options="reSalesAreaOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAgentCodes'"
                    :name="'reAgentCodes'"
                    :select2-options="reAgentCodesOptions"
                    multiple
                    v-model="reAgentCodes"
                  ></select2> -->
                  <treeselect
                    v-model="reAgentCodes"
                    :multiple="true"
                    :options="reAgentCodesOptions"
                    v-on:open="LoadreAgentCodesOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" 
                class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <!-- <h3
            v-if="dataTable.length == 0"
            class="kt-section__title all text-center"
          >
            ไม่พบข้อมูลเบียร์เคลม
          </h3> -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                style="width:4000px;"
              >
                <thead>
                  <tr>
                    <th
                      class="all text-right"
                      v-bind:colspan="
                        brandItem.length +
                          brandItem.length +
                          brandItem.length +
                          brandItem.length +
                          brandItem.length +
                          brandItem.length +
                          12
                      "
                    >
                      ข้อมูล ณ วันที่ {{ reAaDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center" style="width:50px;" rowspan="4">
                      ลำดับ
                    </th>
                    <th
                      class="all text-center"
                      style="width:100px;"
                      rowspan="4"
                    >
                      วันที่ทำเคลม
                    </th>
                    <th
                      class="all text-center"
                      style="width:100px;"
                      rowspan="4"
                    >
                      เขต
                    </th>
                    <th
                      class="all text-center"
                      style="width:250px;"
                      rowspan="4"
                    >
                      ตัวแทนจำหน่าย
                    </th>
                    <th
                      class="all text-center"
                      style="width:150px;"
                      rowspan="4"
                    >
                      ชื่อร้านค้า
                    </th>
                    <th
                      class="all text-center"
                      style="width:150px;"
                      rowspan="4"
                    >
                      ชื่อร้านค้า 2
                    </th>
                    <th
                      class="all text-center"
                      style="width:150px;"
                      rowspan="4"
                    >
                      BARCODE
                    </th>
                    <th
                      class="all text-center"
                      style="width:150px;"
                      rowspan="4"
                    >
                      รหัสทรัพย์สิน(เบียร์สด)
                    </th>
                    <th
                      class="all text-center"
                      style="width:150px;"
                      rowspan="4"
                    >
                      เลขที่ใบแคลม
                    </th>
                    <th
                      class="all text-center"
                      style="width:100px;"
                      rowspan="4"
                    >
                      ผู้อนุมติการเคลม
                    </th>
                    <th
                      style="background-color:LightSkyBlue;"
                      class="all text-center"
                      v-bind:colspan="
                        brandHeader.length +
                          brandHeader.length +
                          brandItem.length
                      "
                    >
                      อนุมัติเคลม
                    </th>
                    <th
                      class="all text-center"
                      style="width:100px;"
                      rowspan="4"
                    >
                      รายละเอียดของปัญหา
                    </th>
                    <th
                      style="background-color:LightPink;"
                      class="all text-center"
                      v-bind:colspan="
                        brandHeader.length +
                          brandHeader.length +
                          brandItem.length
                      "
                    >
                      ไม่อนุมัติเคลม
                    </th>
                    <th
                      class="all text-center"
                      style="width:100px;"
                      rowspan="4"
                    >
                      รายละเอียดของปัญหา
                    </th>
                  </tr>
                  <tr>
                    <th
                      class="all text-center"
                      v-bind:colspan="brandItem.length"
                    >
                      ประเภทถัง (ราคารวม VAT)
                    </th>
                    <th
                      class="all text-center"
                      v-bind:colspan="brandHeader.length + brandHeader.length"
                    >
                      สาเหตุที่เคลม
                    </th>
                    <th
                      class="all text-center"
                      v-bind:colspan="brandItem.length"
                    >
                      ประเภทถัง (ราคารวม VAT)
                    </th>
                    <th
                      class="all text-center"
                      v-bind:colspan="brandHeader.length + brandHeader.length"
                    >
                      สาเหตุที่เคลม
                    </th>
                  </tr>
                  <tr>
                    <th
                      class="all text-center"
                      v-for="header in brandHeader"
                      v-bind:colspan="brandItem.filter((o) => o[0] == header).length">
                      {{ header }}
                    </th>
                    <th
                      class="all text-center"
                      v-bind:colspan="brandHeader.length"
                    >
                      ถังชำรุด
                    </th>
                    <th
                      class="all text-center"
                      v-bind:colspan="brandHeader.length"
                    >
                      น้ำเบียร์ผิดปกติ
                    </th>
                    <th
                      class="all text-center"
                      v-for="header in brandHeader"
                      v-bind:colspan="
                        brandItem.filter((o) => o[0] == header).length
                      "
                    >
                      {{ header }}
                    </th>
                    <th
                      class="all text-center"
                      v-bind:colspan="brandHeader.length"
                    >
                      ถังชำรุด
                    </th>
                    <th
                      class="all text-center"
                      v-bind:colspan="brandHeader.length"
                    >
                      น้ำเบียร์ผิดปกติ
                    </th>
                  </tr>
                  <tr>
                    <th
                      class="all text-center"
                      style="width:50px;"
                      v-for="item in brandItem"
                    >
                      {{ item[1] }}L
                    </th>
                    <th
                      class="all text-center"
                      style="width:80px;"
                      v-for="header in brandHeader"
                    >
                      {{ header }}
                    </th>
                    <th
                      class="all text-center"
                      style="width:80px;"
                      v-for="header in brandHeader"
                    >
                      {{ header }}
                    </th>
                    <th
                      class="all text-center"
                      style="width:50px;"
                      v-for="item in brandItem"
                    >
                      {{ item[1] }}L
                    </th>
                    <th
                      class="all text-center"
                      style="width:80px;"
                      v-for="header in brandHeader"
                    >
                      {{ header }}
                    </th>
                    <th
                      class="all text-center"
                      style="width:80px;"
                      v-for="header in brandHeader"
                    >
                      {{ header }}
                    </th>
                  </tr>
                </thead>
                <tr v-for="(data, index) in dataTable">
                  <template>
                    <td class="all text-center">{{ index + 1 }}</td>
                    <td class="all text-center">{{ data.claimDateString }}</td>
                    <td class="all text-center">{{ data.salesAreaName }}</td>
                    <td class="all text-center">{{ data.agentName }}</td>
                    <td class="all text-center">{{ data.shopName }}</td>
                    <td class="all text-center">{{ data.shopName2 }}</td>
                    <td class="all text-center">{{ data.barCodeNoOld }}</td>
                    <td class="all text-center">{{ data.departmentMaterialCode }}</td>
                    <td class="all text-center">{{ data.claimNumber }}</td>
                    <td class="all text-center"></td>
                    <td class="all text-center" v-for="item in brandItem">
                      <span
                        v-if="
                          data.productBrandName == item[0] &&
                            data.volume == item[1] &&
                            data.claimStatusCode ==
                              'CLAIM_STATUS_CONCLUDE_APPROVE'
                        "
                        >{{
                          data.price
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}</span
                      >
                    </td>
                    <td class="all text-center" v-for="item in brandHeader">
                      <span
                        v-if="
                          data.productBrandName == item &&
                            data.claimStatusCode ==
                              'CLAIM_STATUS_CONCLUDE_APPROVE' &&
                            data.problemTypeCode == 'PROBLEM_TYPE_DAMAGED_TANK'
                        "
                        >{{
                          data.price
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}</span
                      >
                    </td>
                    <td class="all text-center" v-for="item in brandHeader">
                      <span
                        v-if="
                          data.productBrandName == item &&
                            data.claimStatusCode ==
                              'CLAIM_STATUS_CONCLUDE_APPROVE' &&
                            data.problemTypeCode == 'PROBLEM_TYPE_UNUSUAL_TASTE'
                        "
                        >{{
                          data.price
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}</span
                      >
                    </td>
                    <td
                      v-if="
                        data.claimStatusCode == 'CLAIM_STATUS_CONCLUDE_APPROVE'
                      "
                      class="all text-center"
                    >
                      {{ data.problemDesc }}
                    </td>
                    <td
                      v-if="
                        data.claimStatusCode == 'CLAIM_STATUS_CONCLUDE_REJECT'
                      "
                      class="all text-center"
                    ></td>
                    <td class="all text-center" v-for="item in brandItem">
                      <span
                        v-if="
                          data.productBrandName == item[0] &&
                            data.claimStatusCode ==
                              'CLAIM_STATUS_CONCLUDE_REJECT'
                        "
                        >{{
                          data.price
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}</span
                      >
                    </td>
                    <td class="all text-center" v-for="item in brandHeader">
                      <span
                        v-if="
                          data.productBrandName == item &&
                            data.claimStatusCode ==
                              'CLAIM_STATUS_CONCLUDE_REJECT' &&
                            data.problemTypeCode == 'PROBLEM_TYPE_DAMAGED_TANK'
                        "
                        >{{
                          data.price
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}</span
                      >
                    </td>
                    <td class="all text-center" v-for="item in brandHeader">
                      <span
                        v-if="
                          data.productBrandName == item &&
                            data.claimStatusCode ==
                              'CLAIM_STATUS_CONCLUDE_REJECT' &&
                            data.problemTypeCode == 'PROBLEM_TYPE_UNUSUAL_TASTE'
                        "
                        >{{
                          data.price
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}</span
                      >
                    </td>
                    <td
                      v-if="
                        data.claimStatusCode == 'CLAIM_STATUS_CONCLUDE_REJECT'
                      "
                      class="all text-center"
                    >
                      {{ data.problemDesc }}
                    </td>
                    <td
                      v-if="
                        data.claimStatusCode == 'CLAIM_STATUS_CONCLUDE_APPROVE'
                      "
                      class="all text-center"
                    ></td>
                  </template>
                </tr>
                <tfoot>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="all text-center" v-bind:colspan="2">Total</td>
                    <td class="all text-center" v-for="data in brandItem">
                      <span>
                        {{
                          sumTotal(
                            dataTable.filter(
                              (o) =>
                                o.productBrandName == data[0] &&
                                o.volume == data[1] &&
                                o.price > 0 &&
                                o.claimStatusCode ==
                                  "CLAIM_STATUS_CONCLUDE_APPROVE"
                            )
                          )
                        }}
                      </span>
                      <!-- <span>
                        {{ dataTable.filter(
                        (o) =>
                          o.productBrandName == data[0] &&
                          o.volume == data[1] &&
                          o.price > 0 &&
                          o.claimStatusCode == "CLAIM_STATUS_CONCLUDE_APPROVE"
                      ).length * data[2]}}
                      </span> -->
                    </td>
                    <td class="all text-center" v-for="data in brandHeader">
                      <span>
                        {{
                          sumTotal(
                            dataTable.filter(
                              (o) =>
                                o.productBrandName == data &&
                                o.problemTypeCode ==
                                  "PROBLEM_TYPE_DAMAGED_TANK" &&
                                o.claimStatusCode ==
                                  "CLAIM_STATUS_CONCLUDE_APPROVE"
                            )
                          )
                        }}
                      </span>
                      <!-- <span>{{ 
                        dataTable.filter(
                          (o) =>
                            o.productBrandName == data &&
                            o.problemTypeCode == "PROBLEM_TYPE_DAMAGED_TANK" &&
                            o.claimStatusCode == "CLAIM_STATUS_CONCLUDE_APPROVE"
                        ).length * brandItem.filter((o) => o[0] == data)[0][2]
                      }}</span> -->
                    </td>
                    <td class="all text-center" v-for="data in brandHeader">
                      <span>
                        {{
                          sumTotal(
                            dataTable.filter(
                              (o) =>
                                o.productBrandName == data &&
                                o.problemTypeCode ==
                                  "PROBLEM_TYPE_UNUSUAL_TASTE" &&
                                o.claimStatusCode ==
                                  "CLAIM_STATUS_CONCLUDE_APPROVE"
                            )
                          )
                        }}
                      </span>
                      <!-- <span>{{
                        dataTable.filter(
                          (o) =>
                            o.productBrandName == data &&
                            o.problemTypeCode == "PROBLEM_TYPE_UNUSUAL_TASTE" &&
                            o.claimStatusCode == "CLAIM_STATUS_CONCLUDE_APPROVE"
                        ).length * brandItem.filter((o) => o[0] == data)[0][2]
                      }}</span> -->
                    </td>
                    <td></td>
                    <td class="all text-center" v-for="data in brandItem">
                      <span>
                        {{
                          sumTotal(
                            dataTable.filter(
                              (o) =>
                                o.productBrandName == data[0] &&
                                o.volume == data[1] &&
                                o.claimStatusCode ==
                                  "CLAIM_STATUS_CONCLUDE_REJECT"
                            )
                          )
                        }}
                      </span>
                      <!-- <span>{{
                        dataTable.filter(
                          (o) =>
                            o.productBrandName == data[0] &&
                            o.volume == data[1] &&
                            o.claimStatusCode == "CLAIM_STATUS_CONCLUDE_REJECT"
                        ).length * data[2]
                      }}</span> -->
                    </td>
                    <td class="all text-center" v-for="data in brandHeader">
                      <span>
                        {{
                          sumTotal(
                            dataTable.filter(
                              (o) =>
                                o.productBrandName == data &&
                                o.problemTypeCode ==
                                  "PROBLEM_TYPE_DAMAGED_TANK" &&
                                o.claimStatusCode ==
                                  "CLAIM_STATUS_CONCLUDE_REJECT"
                            )
                          )
                        }}
                      </span>
                      <!-- <span>{{
                        dataTable.filter(
                          (o) =>
                            o.productBrandName == data &&
                            o.problemTypeCode == "PROBLEM_TYPE_DAMAGED_TANK" &&
                            o.claimStatusCode == "CLAIM_STATUS_CONCLUDE_REJECT"
                        ).length * brandItem.filter((o) => o[0] == data)[0][2]
                      }}</span> -->
                    </td>
                    <td class="all text-center" v-for="data in brandHeader">
                      <span>
                        {{
                          sumTotal(
                            dataTable.filter(
                              (o) =>
                                o.productBrandName == data &&
                                o.problemTypeCode ==
                                  "PROBLEM_TYPE_UNUSUAL_TASTE" &&
                                o.claimStatusCode ==
                                  "CLAIM_STATUS_CONCLUDE_REJECT"
                            )
                          )
                        }}
                      </span>
                      <!-- <span>{{
                        dataTable.filter(
                          (o) =>
                            o.productBrandName == data &&
                            o.problemTypeCode == "PROBLEM_TYPE_UNUSUAL_TASTE" &&
                            o.claimStatusCode == "CLAIM_STATUS_CONCLUDE_REJECT"
                        ).length * brandItem.filter((o) => o[0] == data)[0][2]
                      }}</span> -->
                    </td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      reAaIsInitial: true,
      reAaDateReq: null,
      reStartDate: null,
      reEndDate: null,
      reSalesArea: [],
      reAgentCodes: [],
      dataTable: [],
      brandHeader: [],
      volume: [],
      brandItem: [],
      reSalesAreaOptions: [],

      reAgentCodesOptions: [],
      // reAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_5S",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.reStartDate = null;
      self.reEndDate = null;
      self.reSalesArea = [];
      self.reAgentCodes = [];
      (self.dataTable = []),
        (self.brandHeader = []),
        (self.volume = []),
        (self.brandItem = []),
        $("#reStartDate")
          .val("")
          .trigger("change");

      $("#reEndDate")
        .val("")
        .trigger("change");

      $("#reSalesArea")
        .val("")
        .trigger("change");

      $("#reAgentCodes")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      let self = this;
      (self.dataTable = []),
        (self.brandHeader = []),
        (self.volume = []),
        (self.brandItem = []),
        this.getDataFromApi();
      e.preventDefault();
      table.draw();
    },
    getDataFromApi() {
      let self = this;
      axios({
        method: "post",
        url: "/Api/Report/AmountBeerClaim",
        data: {
          StartDate:
            self.reStartDate != null
              ? self.reStartDate.format("DD/MM/YYYY")
              : self.reStartDate,
          EndDate:
            self.reEndDate != null
              ? self.reEndDate.format("DD/MM/YYYY")
              : self.reEndDate,
          SalesArea: self.reSalesArea,
          AgentCode: self.reAgentCodes,
          IsInitial: self.reAaIsInitial,
        },
      }).then(function(response) {
        self.dataTable = response.data.data;
        self.dataTable.forEach((e) => {
          let brand = self.brandHeader.includes(e.productBrandName);
          if (!brand) {
            self.brandHeader.push(e.productBrandName);
          }
        });
        self.dataTable.forEach((e) => {
          let brand = self.brandHeader.includes(e.productBrandName);
          if (brand) {
            var list = [];
            list.push(e.productBrandName, e.volume, e.price);
            var item = self.brandItem.filter(
              (o) => o[0] == e.productBrandName && o[1] == e.volume
            );
            if (item.length == 0) {
              self.brandItem.push(list);
            }
          }
        });
        self.reAaIsInitial = false;
      });
    },
    sumTotal(data) {
      var total = 0;
      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          total = total + data[i].price;
        }
      }
      return total
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    LoadreSalesAreaOptions: function(e) {
      var self = this;
      axios
        .get("/Api/MasterSalesArea/FindOptions", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reSalesAreaOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAgentCodesOptions: function(e) {
      var self = this;
      self.reAgentCodesOptions = [{ id:"0",label:"Loading..."}];
      axios
        .post("/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_5S", {
          province_id: [],
          department: [],
          AgentCodes: [],
          SalesAreaIds: self.reSalesArea,
          page: 1,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reAgentCodesOptions = [];
            data.forEach((element) => {
              self.reAgentCodesOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;
    self.LoadreAgentCodesOptions();
    self.LoadreSalesAreaOptions();
    this.getDataFromApi();
    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reStartDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reStartDate = moment().set("date",1);
    $(self.$refs.reStartDate)
      .datepicker(
        "update",
        !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reEndDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.reEndDate)
      .datepicker(
        "update",
        !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
      });
    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/AmountBeerClaim.vue